(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/role/role.tpl.html', [
'<!--',
'',
' * Copyright (C) 2009-2026 by the geOrchestra PSC',
' *',
' * This file is part of geOrchestra.',
' *',
' * geOrchestra is free software: you can redistribute it and/or modify it under',
' * the terms of the GNU General Public License as published by the Free',
' * Software Foundation, either version 3 of the License, or (at your option)',
' * any later version.',
' *',
' * geOrchestra is distributed in the hope that it will be useful, but WITHOUT',
' * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or',
' * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for',
' * more details.',
' *',
' * You should have received a copy of the GNU General Public License along with',
' * geOrchestra.  If not, see <http://www.gnu.org/licenses/>.',
' ',
'-->',
'',
'<section class="role">',
'',
'  <h4>',
'    <a ng-link="roles({\'role\': \'all\'})" translate>role.rolelist</a>',
'    <span>/</span>',
'    {{::role.role.cn}}',
'  </h4>',
'',
'  <hr>',
'',
'  <div class="col-md-2">',
'    <ul class="nav nav-pills nav-stacked">',
'      <li ng-repeat="tab in role.tabs" ng-class="{active: role.tab==tab}">',
'        <a ng-link="role({role: role.role.cn, tab: tab})"',
'          ng-if="!isProtectedRole(role.role) || tab != \'manage\'">{{ \'tab.\' + tab | translate}}</a>',
'      </li>',
'    </ul>',
'  </div>',
'',
'  <div class="col-md-10">',
'',
'    <div class="panel panel-default">',
'',
'      <div class="panel-body" ng-if="role.tab==\'infos\'">',
'        <div ng-inline="templates/roleForm.tpl.html"',
'          ng-init="model=role.role;promise=role.role.$promise;required=role.required;roleTypeValues=role.roleTypeValues"></div>',
'        <hr ng-if="!isProtectedRole(role.role)">',
'        <div class="pull-right" ng-if="!isProtectedRole(role.role)">',
'          <button ng-click="role.save()" class="btn btn-primary" translate>role.save</button>',
'        </div>',
'      </div>',
'',
'      <div class="panel-body" ng-if="role.tab==\'users\'">',
'        <input type="text" class="filter-table form-control pull-right ng-pristine ng-untouched ng-valid ng-empty" ng-model="role.q" placeholder="{{\'role.filter_users\' | translate}}"></input>',
'        <i class="glyphicon glyphicon-remove-sign panel-filter-table-reset" ng-show="role.q != \'\'" ng-click="role.q = \'\'"></i>',
'        <h3 class="roles-title">',
'          <ng-pluralize count="role.users.length"',
'                        when="{\'0\': \'{{ &quot;role.users_none&quot; | translate }}\',',
'                               \'1\': \'{} {{ &quot;role.user&quot; | translate }}\',',
'                               \'other\': \'{} {{ &quot;role.users&quot; | translate }}\'}">',
'        </h3>',
'        <form class="form-inline">',
'          <div class="form-group">',
'            <label for="role" translate>role.userlabel</label>',
'            <select class="pull-right form-control input-sm" ng-model="role.user"',
'               id="role" ng-change="role.associate()"',
'               data-placeholder-text-single="\'...\'"',
'               ng-options="u.uid as (u.sn + \' \' + u.givenName) for u in role.notUsers" chosen>',
'            </select>',
'          </div>',
'        </form>',
'',
'        <table class="table table-striped table-condensed">',
'',
'          <thead>',
'            <tr>',
'              <th translate>users.user</th>',
'              <th translate>user.action</th>',
'            </tr>',
'          </thead>',
'',
'          <tbody>',
'            <tr dir-paginate="user in role.users | filter:role.q | itemsPerPage: role.itemsPerPage | orderBy : \'sn\'">',
'              <td>',
'                <a ng-link="user({id: user.uid, tab: \'infos\'})">{{::user.sn}} {{::user.givenName}}</a>',
'              </td>',
'              <td>',
'                <a href="javascript:void(0)" ng-click="role.associate(user.uid, true)" class="text-danger" title="{{role.i18n.remove}}">',
'                  <i class="glyphicon glyphicon-remove"></i>',
'                </a>',
'              </td>',
'            </tr>',
'          </tbody>',
'',
'        </table>',
'',
'        <dir-pagination-controls></dir-pagination-controls>',
'',
'      </div>',
'',
'      <div class="panel-body" ng-if="role.tab==\'manage\'">',
'        <div class="alert alert-danger clearfix">',
'          <i class="glyphicon glyphicon-exclamation-sign"></i>',
'          <span translate>role.warning</span>',
'          <button ng-click="role.delete()" class="btn btn-danger" translate>role.delete</button>',
'        </div>',
'      </div>',
'',
'  </div>',
'',
'</section>',
'',''].join("\n"));
  }]);
})();